import { apiFetch } from "./client.js";
export const getFood = (date) => apiFetch(`/food${date ? `?date=${date}` : ""}`);
export const addFood = (body) => apiFetch("/food", { method: "POST", body: JSON.stringify(body) });
export const deleteFood = (id) => apiFetch(`/food/${id}`, { method: "DELETE" });
export const updateFood = (id, body) => apiFetch(`/food/${id}`, { method: "PATCH", body: JSON.stringify(body) });
export const estimateFood = (query) => apiFetch("/food/estimate", {
    method: "POST",
    body: JSON.stringify({ query }),
});
export const getTargets = () => apiFetch("/targets");
export const updateTargets = (body) => apiFetch("/targets", { method: "PUT", body: JSON.stringify(body) });
//# sourceMappingURL=nutrition.js.map